import { Text } from '@agro-club/agroclub-shared'
import { parseISO } from 'date-fns'
import useFormatDate from 'hooks/useFormatDate'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DriverDocumentFile } from 'views/pages/LogisticsKR/types'

export const DriverExtraFileInfo = ({ file }: { file: DriverDocumentFile }) => {
  const { t } = useTranslation('logisticsKR')
  const formatDate = useFormatDate()
  const isValidDate = useMemo(() => {
    if (!file.valid_until) return false
    const validDate = parseISO(file.valid_until)
    return validDate.getTime() > Date.now()
  }, [file.valid_until])
  if (!file.valid_until) return null
  return (
    <div>
      <Text typography="bodyMedium" color={isValidDate ? 'secondary' : 'accentDestruct600'}>
        {t('validUntil')} {formatDate(file.valid_until)}
      </Text>
    </div>
  )
}
